import { Stack } from 'expo-router';
import { useTheme } from 'smoothie';

import RedirectFullyAuthedUser from '../../auth/components/middleware/RedirectFullyAuthedUser';

export default function ResetPasswordLayout() {
    const theme = useTheme();

    return (
        <RedirectFullyAuthedUser>
            <Stack
                screenOptions={{
                    headerShown: false,
                    contentStyle: { backgroundColor: theme.background.get() },
                }}
            />
        </RedirectFullyAuthedUser>
    );
}
